import { render, staticRenderFns } from "./qr-code.vue?vue&type=template&id=56f257a0&scoped=true&"
import script from "./qr-code.vue?vue&type=script&lang=js&"
export * from "./qr-code.vue?vue&type=script&lang=js&"
import style0 from "./qr-code.vue?vue&type=style&index=0&id=56f257a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f257a0",
  null
  
)

export default component.exports